import * as React from "react";

const FileUpload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
  >
    <rect width="40" height="40" fill="#F0F8FF" rx="20"></rect>
    <rect width="32" height="32" x="4" y="4" fill="#E0F1FF" rx="16"></rect>
    <path
      fill="#3995E5"
      fillRule="evenodd"
      d="M17.188 18.834a2.8 2.8 0 0 0-.688-.084 2.75 2.75 0 0 0 0 5.5H18a.75.75 0 0 1 0 1.5h-1.5a4.25 4.25 0 0 1 0-8.5m0 0q.532 0 1.05.128a.75.75 0 0 1-.362 1.456"
      clipRule="evenodd"
    ></path>
    <path
      fill="#3995E5"
      fillRule="evenodd"
      d="M23.344 15.968A4.25 4.25 0 0 0 17.75 20a.75.75 0 0 1-1.5 0 5.75 5.75 0 1 1 10.35 3.45.75.75 0 1 1-1.2-.9 4.25 4.25 0 0 0-2.056-6.582"
      clipRule="evenodd"
    ></path>
    <path
      fill="#3995E5"
      fillRule="evenodd"
      d="M20.97 19.47a.75.75 0 0 1 1.06 0l2.12 2.118a.75.75 0 0 1-1.061 1.061L21.5 21.061l-1.588 1.588a.75.75 0 1 1-1.061-1.06z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#3995E5"
      fillRule="evenodd"
      d="M21.5 19.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default FileUpload;
